var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "state-pane" },
    [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("div", { staticClass: "card-header" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "hd-actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "small",
                      disabled: !_vm.selection.length,
                      loading: _vm.updating,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.confirmBatch(1)
                      },
                    },
                  },
                  [
                    _c("bi-label", {
                      attrs: {
                        zh: "批量启用",
                        pt: "Ativar em Lote",
                        inline: "",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "small",
                      disabled: !_vm.selection.length,
                      loading: _vm.updating,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.confirmBatch(0)
                      },
                    },
                  },
                  [
                    _c("bi-label", {
                      attrs: {
                        zh: "批量停用",
                        pt: "Desativar em Lote",
                        inline: "",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "card-tip" }, [
            _vm._v(" 已选 "),
            _c("b", [_vm._v(_vm._s(_vm.selection.length))]),
            _vm._v(" 个州，共 "),
            _c("b", [_vm._v(_vm._s(_vm.rows.length))]),
            _vm._v(" 个州；停用后该州不再参与定时检查与告警推送。 "),
            _c("span", { staticClass: "tip-pt" }, [
              _vm._v(
                " / " +
                  _vm._s(_vm.selection.length) +
                  " estado(s) selecionado(s) de " +
                  _vm._s(_vm.rows.length) +
                  "; estados desativados não entram na verificação agendada nem nos alertas. "
              ),
            ]),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "tableRef",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.rows, size: "mini", border: "" },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "46", align: "center" },
              }),
              _c(
                "el-table-column",
                {
                  attrs: { prop: "uf", "min-width": "140" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("span", { staticClass: "uf-cell" }, [
                            _vm._v(_vm._s(row.uf)),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "州（UF）", pt: "Estado (UF)" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "span",
                            {
                              class: [
                                "st-tag",
                                row.status === 1 ? "st-on" : "st-off",
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(row.status === 1 ? "启用" : "停用") +
                                  " "
                              ),
                              _c("span", { staticClass: "st-pt" }, [
                                _vm._v(
                                  "/ " +
                                    _vm._s(
                                      row.status === 1
                                        ? "Ativado"
                                        : "Desativado"
                                    )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "状态", pt: "Status" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "110", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("toggle-switch", {
                            attrs: {
                              value: row.status === 1,
                              "on-text": "点击停用 / Clique para desativar",
                              "off-text": "点击启用 / Clique para ativar",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleToggle(row)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "启用监控", pt: "Ativar" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "tbl-empty",
                  attrs: { slot: "empty" },
                  slot: "empty",
                },
                [
                  _vm._v(" 接口暂无监控州数据 "),
                  _c("span", { staticClass: "empty-pt" }, [
                    _vm._v("/ Nenhum estado retornado pela API"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("confirm-dialog", {
        attrs: {
          visible: _vm.confirmVisible,
          title: _vm.confirmOpts.title,
          "title-pt": _vm.confirmOpts.titlePt,
          subtitle: _vm.confirmOpts.subtitle,
          desc: _vm.confirmOpts.desc,
          "desc-pt": _vm.confirmOpts.descPt,
          "ok-text": _vm.confirmOpts.okText,
          "ok-text-pt": _vm.confirmOpts.okTextPt,
          kind: _vm.confirmOpts.kind,
        },
        on: {
          "update:visible": function ($event) {
            _vm.confirmVisible = $event
          },
          confirm: _vm.confirmOpts.onOk,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticStyle: { "margin-top": "0" } }, [
      _c("span", [_vm._v("监控州范围")]),
      _c("span", { staticClass: "ch-pt" }, [
        _vm._v("Escopo de Estados Monitorados"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }